import React, { useContext } from 'react';

// Openlayers
import { transform } from 'ol/proj';

// Custom Components
import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

// Models
import modelNekretnine from '@/models/nekretnine';
import modelNekretnineZalbe from '@/models/zalbe';

// Types
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import UserContext from '@/context/UserContext/UserContext';

import NekretninaDialog from './NekretninaDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';

type NekretnineDataCentricPageParams = {};

const NekretnineDataCentricPage = (props: NekretnineDataCentricPageParams) => {
  const userContext = useContext(UserContext);

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    
    const hasObjektId = record?.objekt_id !== null;

    const hasCx = record?.cx !== null;
    const hasCy = record?.cy !== null;
    const hasCz = record?.cz !== null;

    switch (action) {
      case 'show_object':
        return hasObjektId;
      case 'show_3d':
        return hasCx && hasCy && hasCz;
      case 'show_photos':
        return hasObjektId;
      default:
        return false;
    }
  };

  const handleCustomAction = (action: string, id: number, record?: { [key: string]: any }) => {
    let locationId: number | null = null;
    if (record && 'lokacija_id' in record) {
      locationId = record.lokacija_id as number;
    }
    let objektId: number | null = null;
    if (record && 'objekt_id' in record) {
      objektId = record.objekt_id as number;
    }
    switch (action) {
      case 'show_object':
        if (id) {
          const locId = locationId === null ? '' : `&loc_id=${locationId}`;
          const url = `${location.origin}/ena/utility/?obj_id=${id.toString()}&open_first=true${locId}`;
          window.open(url, '_blank');
        }
        break;
      case 'show_3d':
        if (record) {
          const [cx, cy] = transform([record?.cx, record?.cy], 'EPSG:3765', 'EPSG:4326').map((x) => (x * Math.PI) / 180);

          // navigate("/3d", { state: { cx: cx, cy: cy, cz: record?.cz}}) //(opens in the same tab)
          const url = `${location.origin}/3d/?cx=${cx.toString()}&cy=${cy.toString()}&cz=${record?.cz.toString()}`;
          window.open(url, '_blank'); // opens in a new tab
        }
        break;
      case 'show_photos':
        if (id) {
          const objId = objektId === null ? '' : `?rec_id=${objektId}`;
          const url = `${location.origin}/ena/photodoc/${objId}`;
          window.open(url, '_blank');
        }
        break;
      default:
        break;
    }
  };

  const viewName = userContext?.hasAnyPermission([Permissions.ThreeDView])
    ? 'default_with_3d'
    : 'default';

  const canManage = userContext?.hasAnyPermission([Permissions.EnaManageNekretnine]);

  return (
    <AppPage
      titlett="ena:page.nekretnine"
      needPermission={[Permissions.EnaViewNekretnine]}
    >
      <DataCentricPage
        primaryModel={modelNekretnine}
        primaryTitleToken="titles.porez_na_nekretnine"
        primaryView={viewName}
        primaryAllowEdit={canManage}
        primaryDialogComponent={NekretninaDialog}
        primaryDialogForm="default"
        baseRecordPath={modelNekretnine.apiPath}
        
        allowCustomTableAction={allowRowAction}
        onCustomTableAction={handleCustomAction}

        secondaryModel={modelNekretnineZalbe}
        secondaryTitleToken="ena:titles.nekretnina_zalbe"
        secondaryView="obveza_zalbe"
        secondaryAllowEdit={canManage}
        secondaryAllowDocumentButton={canManage}
        childRecordRelativePath="zalbe"
        
        mapId={27}
        mapModel={modelNekretnine}
        geomRelativePath=""
      />
    </AppPage>
  );
};

export default NekretnineDataCentricPage;